import React from 'react';
import ReactDOM from 'react-dom/client';
import WhatsAppApp from './components/WhatsApp/WhatsAppApp';
import { ErrorBoundary, captureGlobalErrors } from './shared/ErrorBoundary';
import { waitForPendingWrites } from 'firebase/firestore';
import { db } from './shared/firebase';
import { vigilarVersion } from './shared/nuevaVersion';
import './components/Calculator/calculator.css'; // Tailwind + EasyDebt tokens
import './shared/marcaAzul.css'; // azul exacto de la guía de marca

// Standalone WhatsApp management console (separate from the EasyDebt admin).
const root = ReactDOM.createRoot(document.getElementById('root'));
captureGlobalErrors('whatsapp');
// Las pestañas abiertas pasan solas a la versión nueva (src/shared/nuevaVersion.ts).
vigilarVersion({ esperarEscrituras: () => waitForPendingWrites(db) });

root.render(
    <React.StrictMode>
        <ErrorBoundary app="whatsapp">
            <WhatsAppApp />
        </ErrorBoundary>
    </React.StrictMode>
);
